import Vue from 'vue'
import VueRouter from 'vue-router'
import {commonRouter} from "./routes"
import {getStorage} from '@/storage'
import store from '@/store'
import {isNewVersion} from '@/util/version'
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: commonRouter
})

router.beforeEach( async(to, from, next) => {
  console.log(to)
  if(to.path != '/home/index' && to.path != '/login') {
    let str = {
      path: to.path,
      title: to.meta.title
    }
    store.commit('setRouterArr', str)
  }
  let token = getStorage('token')
  if(!token){
    to.path === "/login" ? next() : next('/login');
    return false;
  }
  //版本校验 - 在路由跳转前检查
  // 登录后跳转不要检测、退出登录不要检测、以免造成问题
  if(from.path != "/login" && to.path != "/login") {
    const canContinue = await isNewVersion();
    if (!canContinue) {
      //如果版本校验不通过（发现新版本），阻止路由跳转
      next(false);
      return false;
    }
  }
  if(token){
    next()
  } 
})

router.afterEach((to, from) => {
  if(from.path == '/login' || to.path == '/login'){
    isNewVersion()
  }
});
export default router
